<template>
  <div class="choose-company">
    <div class="bac"></div>
    <div class="content">
      <div class="wrap">
        <p><span></span><span>精密客流分析平台<i>项目端</i></span></p>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="project">
            <p>项目名称</p>
            <el-select v-model="form.project" placeholder="请选择项目" clearable>
              <el-option v-for="(value, index) in projectOptions" :key="index" :label="value.project_attr_name" :value="value.project_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="text" @click="returnLogin">返回登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="pic"></div>
    </div>
  </div>
</template>

<script>
  import EntranceService from '@/io/entrance.js';

  export default {
    name: 'ChooseCompany',
    data() {
      return {
        form: {
          project: ''
        },
        rules: {
          project: [
            {
              required: true, message: '请选择项目'
            }
          ]
        },
        projectOptions: []
      }
    },
    mounted() {
      EntranceService.projectList().then(res => {
        this.projectOptions = res.data;
      }).catch(() => {});
    },
    methods: {
      submit() {
        this.$refs.form.validate(res => {
          if (res) {
            EntranceService.login(this.form.project).then(res => {
              this.$message.success('登录成功');
              this.$router.replace({
                path: this.$route.query.redirect || '/'
              });
            }).catch(() => {});
          }
        });
      },
      returnLogin() {
        EntranceService.logout();
        this.$router.replace({
          path: '/entrance'
        });
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .choose-company {
    height: 100%;
    background-color: @color-primary;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .bac {
      .setImg('/entrance/bac.png');
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
    .content {
      background-color: @color-white;
      width: 820px;
      height: 472px;
      border-radius: 12px;
      position: relative;
      z-index: 1;
      .pic {
        .setImg('/entrance/pic.png');
        position: absolute;
        top: 0;
        right: 0;
      }
      .wrap {
        width: 320px;
        position: absolute;
        top: 50%;
        left: 40px;
        transform: translate3d(0, -50%, 0);
        z-index: 1;
        & > p {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;
          span {
            &:nth-of-type(1) {
              .setImg('/common/logo.png');
              width: 40px;
              height: 40px;
              margin-right: 10px;
            }
            &:nth-of-type(2) {
              font-size: 24px;
              font-weight: bold;
              color: @color-text-1;
              position: relative;
              width: 244px;
              i {
                font-size: 12px;
                color: @color-white;
                font-style: normal;
                position: absolute;
                background-color: @color-primary;
                padding: 4px 8px;
                transform: scale(.7);
                font-weight: normal;
                border-radius: 4px;
                top: 1px;
                right: 4px;
              }
            }
          }
        }
      }
    }
    .el-form {
      .el-form-item {
        .el-form-item__content {
          & > p {
            color: @color-text-3;
            line-height: initial;
            margin-bottom: 10px;
          }
        }
      }
    }
    .el-button {
      width: 100%;
      &:nth-of-type(2) {
        text-align: left;
        margin-left: 0;
      }
    }
  }
</style>